var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_vm._m(0),_c('div',{staticClass:"col-auto pt-1",domProps:{"innerHTML":_vm._s(_vm.insert)}}),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col pr-0"},[_c('hr')])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col pl-0"},[_c('hr')])
}]

export { render, staticRenderFns }